import type { PropsWithChildren } from 'react';

import { twMerge } from 'tailwind-merge';

import { LeftHeaderSectionSkeleton } from './left-header-with-back-skeleton';
import { PageHeader } from './page-header';
import { StickyContainer } from './sticky-container';

export function StickyPageHeaderSkeleton({
  children,
  isModal = false,
  allowBack = false,
  withBreadcrumb = false,
}: PropsWithChildren<{
  isModal?: boolean;
  allowBack?: boolean;
  withBreadcrumb?: boolean;
}>) {
  return (
    <StickyContainer className={twMerge('', isModal && 'top-0 mx-px rounded-t-3xl')}>
      <PageHeader isModal={isModal}>
        <LeftHeaderSectionSkeleton allowBack={allowBack} withBreadcrumb={!isModal && withBreadcrumb} />
        {children}
      </PageHeader>
    </StickyContainer>
  );
}
